<template>
  <div class="lesson-item" @click="go">
    <img :src="iconUrl || defaultImg">
    <div class="lesson-item-content">
      <h4>{{title}}</h4>
      <div class="lesson-item-tag-wrapper">
        <span v-if="firstClassName">{{firstClassName}}</span>
        <span v-if="secondClassName">{{secondClassName}}</span>
        <span v-if="required === 1" class="required">必修</span>
        <span v-else>选修</span>
      </div>
      <div class="lesson-item-extra">
        <span>{{releaseTime}}更新</span>
        <span v-if="credit && `${credit}` !== '0'">{{credit}}学分</span>
        <span>{{learnedCount}}人已学</span>
      </div>
    </div>
  </div>
</template>

<script>
import defaultImg from '../assets/icon_train_default.png'

export default {
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    iconUrl: {
      type: String,
      default: ''
    },
    releaseTime: {
      type: String,
      default: ''
    },
    credit: {
      type: String,
      default: ''
    },
    required: {
      type: Number,
      default: 0
    },
    learnedCount: {
      type: Number,
      default: 0
    },
    firstClassName: {
      type: String,
      default: ''
    },
    secondClassName: {
      type: String,
      default: ''
    },
    timeLimitFlag: {
      type: Boolean,
      default: false
    },
    deadlineDaysStr: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      defaultImg
    }
  },
  methods: {
    go () {
      this.$router.push(`/lesson-detail/${this.id}`)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/variable.styl';

.lesson-item {
  margin: 0 30px;
  display: flex;
  align-items: center;
  min-width: 0;
  border-top: 1PX solid $ucar_light_border;
  
  &:last-of-type {
    border-bottom: 1PX solid $ucar_light_border;
  }

  img {
    width: 144px;
    height 144px;
  }

  .lesson-item-content {
    padding: 20px 0 20px 20px;

    h4 {
      font-size: $ucar_font_h4;
      margin-bottom: 20px;
    }

    .lesson-item-tag-wrapper {
      margin-bottom: 20px;

      span {
        font-size: $ucar_font_h6;
        height: 40px;
        margin-right: 20px;
        padding: 0 6px;
        border: 1PX solid currentColor;
        border-radius: 6px;

        &.required {
          color: $ucar_main_color;
        }
      }
    }

    .lesson-item-extra {
      
      span {
        display: inline-block;
        line-height: $ucar_font_h5;
        font-size: $ucar_font_h5;
        padding-right: 10px;
      }

      span + span {
        padding-left: 10px;
        border-left: 1PX solid currentColor;
      }
    }
  }
}
</style>